import React from "react";
import { Box, Stack } from "@mui/material";
import Header from "../../components/Header"; // assuming you already have this
import AuthButtons from "../../components/AuthButtons";

export default function SplashPage() {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        // animated gradient background
        background:
          "linear-gradient(-45deg, #141b2d, #2e7c67, #141b2d, #4cceac)",
        backgroundSize: "400% 400%",
        animation: "gradientBG 15s ease infinite",
      }}
    >
      {/* Inner content */}
      <Box>
        <Header
          title="WeezDraftboard"
          subtitle="Your Draft. Your Board. Your Edge."
        />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 4 }}
        >
          <AuthButtons />
        </Stack>
      </Box>

      {/* gradient keyframes */}
      <style>
        {`
          @keyframes gradientBG {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
    </Box>
  );
}
